export default function getInitials(name) {
  if (!name) return 'AN';
  const rgx = new RegExp(/\b(\w)/g);
  const initials = name.match(rgx);
  let capitalizedInitials = initials.filter((letter) => letter === letter.toUpperCase());
  if (capitalizedInitials.length > 2) {
    capitalizedInitials = capitalizedInitials.slice(0, 2);
    return capitalizedInitials.join('').toUpperCase();
  }
  if (capitalizedInitials.length <= 1) {
    if (initials.length > 2) return initials.slice(0, 2).join('').toUpperCase();

    return initials.join('').toUpperCase();
  }
  return (
    capitalizedInitials.join('').toUpperCase()
  );
}
